// extracted by mini-css-extract-plugin
export default {"wrapper":"GamesArea_wrapper__HkoAF","date":"GamesArea_date__5h5+i","datePicker":"GamesArea_datePicker__5kQLw","dateArrow":"GamesArea_dateArrow__1OzuI"};